import BaseFeature from '../../foundation/base/base';

const classes = {
	expansionBlockActive: 'o-expansion-block__item--active',
};

export default class expansionBlock extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();
		this.el = element;
		this.expansionBlockButtons = this.el.querySelectorAll('.js-expansion-block-button');
		this.initEvents();
	}

	initEvents() {
		this.addEventListener(this.el, 'click', (e) => {
			const expansionBlockButton = e.target.closest('.js-expansion-block-button');
			if (expansionBlockButton) {
				e.preventDefault();
				this.toggleExpansionBlock(expansionBlockButton, expansionBlockButton.parentNode);
			}
		});
	}

	toggleExpansionBlock(expansionBlockButton, expansionBlockItem) {
		const expansionBlockPanel = expansionBlockButton.nextElementSibling;
		const newHeight = expansionBlockPanel.firstChild.nextElementSibling.offsetHeight;

		if (expansionBlockItem.classList.contains(classes.expansionBlockActive)) {
			expansionBlockItem.classList.remove(classes.expansionBlockActive);
			expansionBlockButton.setAttribute('aria-expanded', 'false');
			expansionBlockPanel.setAttribute('aria-hidden', 'true');
			expansionBlockPanel.style.maxHeight = expansionBlockPanel.offsetHeight + 'px';
			expansionBlockPanel.style.maxHeight = 0 + 'px';
		} else {
			expansionBlockItem.classList.add(classes.expansionBlockActive);
			expansionBlockButton.setAttribute('aria-expanded', 'true');
			expansionBlockPanel.setAttribute('aria-hidden', 'false');
			expansionBlockPanel.style.maxHeight = newHeight + 'px';
		}
	}
}